import {ChangeDetectorRef, Component} from '@angular/core';
import {BlockBaseComponent} from "../block-base/block-base.component";
import {MatDialog} from "@angular/material/dialog";
import {TranslocoService} from "@ngneat/transloco";
import {StoreSelectorsService} from "../../../../services";
import {ITableListColumn} from "../../../../components/table-list-input/table-list-input.component";
import {IButtonBar} from "../../../../components/add-remove-bar/button-bar.component";
import {IFormItem} from "../../../../interfaces";

@Component({
  selector: 'app-scene-block-form',
  templateUrl: './block-form.component.html',
  styleUrls: ['./block-form.component.scss']
})

export class BlockFormComponent extends BlockBaseComponent {
  tableColumns: Array<ITableListColumn> = [];
  buttons: IButtonBar[] = [];

  constructor(private translocoService: TranslocoService, public override storeSelector: StoreSelectorsService, public override dialog: MatDialog, public cd: ChangeDetectorRef) {
    super(storeSelector, dialog);
    this.tableColumns = [{
      inputType: 'edit',
      name: 'name',
      maxStringSize: '12'
    }, {
      inputType: 'edit',
      name: 'label',
      maxStringSize: '12'
    }, {
      inputType: 'edit',
      name: 'softKeyboard',
      maxStringSize: '12'
    }];
    this.buttons = [
      {
        callBack: v => (v),
        icon: 'add',
        name: 'add',
        disableByList: false,
        disabled: false,
        tooltip: this.translocoService.translate('general.add', {}, this.translocoService.getActiveLang())
      },
      {
        callBack: v => (v),
        icon: 'remove',
        name: 'remove',
        confirmRemove: this.translocoService.translate('toast.deleteConfirm', {}, this.translocoService.getActiveLang()),
        disableByList: true,
        disabled: false,
        tooltip: this.translocoService.translate('general.remove', {}, this.translocoService.getActiveLang())
      },
      {
        callBack: v => (v),
        icon: 'arrow_left',
        name: 'previous',
        disableByList: true,
        disabled: false,
        tooltip: this.translocoService.translate('general.next', {}, this.translocoService.getActiveLang())
      },
      {
        callBack: v => (v),
        icon: 'arrow_right',
        name: 'next',
        disableByList: true,
        disabled: false,
        tooltip: this.translocoService.translate('general.previous', {}, this.translocoService.getActiveLang())
      }
    ];
  }

  override submit(formValues) {
    if (formValues?.Item?.currentAction === 'added') {
      const pager: IFormItem = {
        $: {
          label: 'text',
          name: 'name',
          defaultValue: '',
          required: '',
          softKeyboard: '',
          type: ''
        }
      };
      const pages: Array<IFormItem> = formValues.Item.values;
      pages.push(pager);
      this.dispatchSceneItemChanges({
        sceneId: this.sceneId,
        sceneItemId: this.sceneItem.$.id,
        values: [{
          key: 'Item',
          value: pages,
          storePath: 'Data[0].Form[0].List[0]'
        }]
      });
      super.initApplyStoreToDynamic(true);
    }
    super.submit(formValues);
  }

  override componentInit() {
    super.componentInit();
  }

  override componentStoreUpdates() {
    super.componentStoreUpdates();
    this.cd.detectChanges();
  }

  override initRegisterDynamic() {
    this.uiConfigInit = [
      {
        type: "input",
        label: '',
        inputType: 'tablelist',
        tableColumns: this.tableColumns,
        ignoreMissingValue: true,
        cloneVals: true,
        multiSelect: false,
        rememberSelection: true,
        allowFilter: true,
        buttonBarClassName: 'formListButtonBar',
        buttons: this.buttons,
        inputEditFormat: {page: 'text', label: 'text', softKeyboard: 'text'},
        inputEditRenamePath: [{path: '$.name', key: 'name'}, {path: '$.label', key: 'label'}, {
          path: '$.softKeyboard',
          key: 'softKeyboard'
        }],
        name: "Item",
        expandableEditor: true,
        storePath: 'Data[0].Form[0].List[0].Item',
        // callBack: (v) => this.onTableListChangeCallBack(v)
      }
      // ,{
      //     type: "checkbox",
      //     value: '1',
      //     label: this.translocoService.translate('general.gpu', {}, this.translocoService.getActiveLang()),
      //     name: "gpu",
      //     storePath: '$.gpu'
      // }
    ];
  }
}

